import React from 'react';

function CryptoAmountInput({ label, value = '', onChange, containerStyle = {} }) {
  const extractDigits = (val) => (val || '').replace(/\D/g, '');

  const formatCryptoValue = (digits) => {
    const padded = digits.padStart(6, '0');
    const integerPart = padded.length > 6 ? padded.slice(0, padded.length - 6) : '0';
    const decimalPart = padded.slice(-6);
    return `${parseInt(integerPart, 10)}.${decimalPart}`;
  };

  const handleInputChange = (e) => {
    const inputValue = e.nativeEvent.data;
    const digitsOnly = extractDigits(value || '');

    if (/\d/.test(inputValue)) {
      const newDigits = (digitsOnly + inputValue).replace(/^0+/, '');
      const formatted = formatCryptoValue(newDigits);
      if (onChange) onChange(formatted);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Backspace') {
      const digitsOnly = extractDigits(value || '');
      const newDigits = digitsOnly.slice(0, -1);
      const formatted = formatCryptoValue(newDigits);
      if (onChange) onChange(formatted);
      e.preventDefault();
    }
  };

  const displayValue = value || '0.000000';

  return (
    <div style={{ marginBottom: '15px', ...containerStyle }}>
      <label style={{ color: '#aaa', fontSize: '12px' }}>{label}</label><br />
      <input
        type="text"
        value={displayValue}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        inputMode="numeric"
        style={{
          color: "#061B2B",
          fontWeight: "bold",
          fontSize: "14px",
          textAlign: "left",
          border: "1px solid #EBEBED",
          borderRadius: "4px",
          width: "100%",
          height: "35px",
          paddingLeft: "10px",
          backgroundColor: "#EBEBED"
        }}
      />
    </div>
  );
}

export default CryptoAmountInput;
